import React, { createContext, useState, useContext, useEffect } from "react";

import { getStoredState, updateStoredState } from "../utils/localStorage";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => getStoredState()?.user || null);

  useEffect(() => {
    updateStoredState({ user });
  }, [user]);

  const clearUser = () => {
    setUser(null);
    updateStoredState({ user: null });
  };

  return (
    <UserContext.Provider value={{ user, setUser, clearUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);

